import { useParams, useSearchParams } from 'react-router-dom';

import SectionedLayout from './Sectioned/Layout';
import SectionedAuditRenderer from './Sectioned/SectionedAuditRenderer';
import { useGetSectionedAuditHistory } from './hooks';

export default function SectionedAuditHistory() {
  const { pageEnum, entityEnum } = useParams();

  const [searchParams] = useSearchParams();

  const references: Record<string, string> = {};
  for (const key of searchParams.keys()) {
    const value = searchParams.get(key);
    if (value !== null) {
      references[key] = value;
    }
  }

  const {
    data: sectionedAuditPage,
    isLoading,
    isError,
  } = useGetSectionedAuditHistory(pageEnum, entityEnum, references);
  return (
    <SectionedLayout
      pageEnum={pageEnum}
      isLoading={isLoading}
      isError={isError}
      isDataEmpty={!sectionedAuditPage?.sections?.length}
      customTitle={sectionedAuditPage?.pageTitle}
      category={sectionedAuditPage?.category}
    >
      <SectionedAuditRenderer sections={sectionedAuditPage?.sections} />
    </SectionedLayout>
  );
}
